import l from '../../../../lang';
import CardConfirm from '../../../common/confirm/card-confirm';
import DialogConfirm from '../../../common/confirm/dialog-confirm';

interface DialogRestoreUserProps {
  userEmail: string;
  onClose: (confirm: boolean) => void;
}

const DialogRestoreUser = ({ userEmail, onClose }: DialogRestoreUserProps) => {
  return (
    <DialogConfirm onClose={() => onClose(false)}>
      <CardConfirm
        onClose={onClose}
        headline={l('userManagement.restore.title')}
        description={l('userManagement.restore.body', `${userEmail}`)}
        confirmChildren={l('userManagement.restore.confirm')}
        cancelChildren={l('userManagement.restore.cancel')}
        level={'warning'}
      />
    </DialogConfirm>
  );
};

export default DialogRestoreUser;
